<!-- listBoxInput.vue -->

<template>
  <div class="component-container" style="font-family: inherit; position: relative;min-width: 100%;">
    <div class="form-floating component-form-container" >
        <input 
            v-model="searchText"
            :class="['form-control', formData.fields[fieldName].class]"
            @input="(!searchIn.alwaysList) ? searchList() : null"
            @blur="leaveFromInput"
            @focus="inToInput"
            :name="name"
            @keydown.enter.prevent="searchTexto"
            :id="formData.fields[fieldName].id"
            :required="formData.fields[fieldName].required"
            :disabled="formData.fields[fieldName].readonly === true"
            autocomplete="off"
            :placeholder="['Escribe una ', formData.fields[fieldName].label]"
        />
        <label :for="formData.fields[fieldName].id">{{ formData.fields[fieldName].label }}</label>
        <div @click="clearInput"><i class="fas fa-times clear-input" ></i></div>
        <div v-show="isLoading" class="loading-icon"><i class="fas fa-cog fa-spin"></i></div>
        <!-- Icono de triángulo -->
        <div class="dropdown-icon"><i class="fas fa-caret-down"></i></div>
    </div>
   <ul @mouseenter="overList" @mouseleave="leaveList" v-if="showListToSelect" class="list-group shadow-lg mt-2 pl-0 mb-0">
        <li 
            v-for="regList in matchingValues"
            :key="regList.id_"
            @click="selectregList(regList)"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
            >
            <span v-if="!searchIn.show">{{ regList[searchIn.field] }} <div v-if="searchIn.show" class="pl-2 border h5">{{ regList[searchIn.show] }}</div></span>
            <span v-if="searchIn.show" class="" v-html="prepareShow(regList, searchIn.show)"></span>
        </li>
    </ul>
    <div v-if="formData.fields[fieldName].msg" class="helpMessage" style="width: 100%;">
        <p style="text-align: justify; margin: 0;" v-html="formData.fields[fieldName].msg"></p>
    </div>


  </div>
</template>


<script>
const { replaceKeys } = require('@/js/utils.js');

export default {
    props: {
        fieldData: { type: Object, required: true },
        formValues: { type: Object, },
        formData: { type: Object, required: true },
        fieldName: { type: String, required: true },
        name: {type: String}
    },
  watch: {
    fieldData(newVal) {
        this.searchText = newVal;
    }
  },

  computed: {
        fieldValue() {
            return this.fieldData;
        },
        showListToSelect() {
            return this.showList;
        }
   },
  data() {
    return {
      searchText: this.fieldData || '',
      matchingValues: [],
      searchIn : this.formData.fields[this.fieldName].component,
      showList: false,
      swOverList: false,
      lastSearch : ""
    };
  },
  methods: {
    async searchList() {

       if (this.formData.fields[this.fieldName].alwaysList) return;
       if (this.searchText.length < 3  ) return ;

       this.searchText = this.checkCase(this.searchText);
       if (this.searchText == this.lastSearch ) return ;

       this.searchListFrom();
    },
    async searchTexto() {
        if (this.formData.fields[this.fieldName].alwaysList) return;
        if (this.searchText.length < 1  ) return ;
         this.searchText = this.checkCase(this.searchText);
       if (this.searchText == this.lastSearch ) return ;

       this.searchListFrom();
    },
    async overList() {
        this.swOverList=true;
    },
    async leaveList() {
        this.swOverList=false;
    },
    inToInput() {
        if (!this.searchTex) this.searchTex = "";
        console.log("inToInput:",this.searchIn,this.matchingValues.length)
        if (this.searchIn.alwaysList && (this.matchingValues.length==0 || !this.matchingValues)) {
            this.searchListFrom();
            return
        }
        if (!this.showList && this.matchingValues.length>0 ) this.showList = true;

        if (this.searchText.length < 3 ) return;

        if (this.searchText.length >= 3 && this.lastSearch != this.searchText )  this.searchListFrom();
        if (this.searchText.length >= 3 && this.lastSearch == this.searchText && this.matchingValues.length > 0 ) this.showList=true;
    },
    async leaveFromInput() {
        if (! this.swOverList) {
            this.showList=false;
            if (this.searchText != this.fieldData) this.searchText= (this.fieldData) ? this.fieldData : "";
        }
    },
    async searchListFrom() {
        console.log("searchListFrom....", this.searchIn.alwaysList)
        if (!this.matchingValues) this.matchingValues = [];
        if (this.matchingValues.length > 0 && this.searchIn.alwaysList) { this.showList = true; return; }
        this.showList = false;

       if (this.searchIn.from === "FS")  this.matchingValues = await this.getFirestore(this.searchIn);
       else  if (this.searchIn.from.toLowerCase() === "api") this.matchingValues = await this.getFromApi(this.searchIn);
       else this.matchingValues = (this.searchIn.options) ? this.searchIn.options : [];
       if (this.matchingValues.length>0) this.showList = true;
       else this.showList=false;
    },
    async getFirestore(searchIn) {
        let query = this.$Genv.fsCia.collection(searchIn.collection)
        if (this.searchText.length > 0 && !this.searchIn.alwaysList) {
            query = query.where(searchIn.field, ">=", this.searchText).where(searchIn.field, "<=", this.searchText + "\uf8ff")
            this.lastSearch = this.searchText;
        }
        const dataCol = await query.get(true);
        return this.prepareListToSelect(dataCol, searchIn);
      },
      async getFromApi(searchIn) {
        console.log("searchIn.params:",searchIn.params)
        const params = {...{"term":this.searchText}, ...{"params": (searchIn.params) ? replaceKeys(searchIn.params,this.formValues): ""}}
        console.log("searchIn=>params:",params)

        const st = await this.$ajax(searchIn.action || searchIn.collection,params,"terms" )
        console.log("getFromApi:"+searchIn.action, st)
        return this.prepareListToSelect(st.data, searchIn);
    },
      prepareListToSelect(dataCol, searchIn) {
        console.log("prepareListToSelect:",dataCol)
        const isVarFields = /{{[\w\-_]+}}/.test(searchIn.key);
        const vars = (isVarFields) ? this.$arMatchs(searchIn.key) : false;
        //console.log("Col:"+searchIn.collection+" field:"+searchIn.field+" search:"+this.searchText+" l:"+this.searchText.length," data:",dataCol)
       
        const data = ((j,C) => {
                for (let c in C ) {
                    const key = (isVarFields ) ? this.getKey(vars,C[c],searchIn.key) : C[c][searchIn.key];
                    j[key]=C[c];
                } 
                return j
            })({}, dataCol)
        let rt = ((j, C) => { for (let c in C) j.push(C[c]); return j })([], data);
        console.log("LIST:",rt)
        return rt;
        //return ((j,C) => {for (let c in C) j.push(C[c]); return j})([],data) ;
    },

    getKey(vars,data,key) {
       let strKey=key;
       // eslint-disable-next-line no-useless-escape
       for (let v in vars) strKey = strKey.replace(new RegExp("\{\{"+vars[v]+"\}\}","gm"),data[vars[v]])
        return strKey;
      },
     clearInput() {
        console.log("clearInput:"+this.searchText)
        this.searchText = ''; // Limpia el campo de entrada
        this.selectregList({[this.fieldName]:""});
    },
    selectregList(regList) {
        // eslint-disable-next-line 
        //debugger;
        this.showList=false;

        if (!this.searchIn.set) this.searchIn.set = {[this.fieldName]: this.searchIn.field}
        if (!this.searchIn.set[this.fieldName]) this.searchIn.set[this.fieldName] =  this.searchIn.field;
        const json = {...this.searchIn.set}

        for (const f in json) json[f] =  (!json[f]) ? "" : regList[json[f]] || null ;

        this.$emit('input-change', json);
        return;
      //this.matchingValues = [];
    },
    prepareShow(regList,showStr) {
        return replaceKeys(showStr, regList);
    },
    checkCase(inputValue) {
        const currentClass = this.formData.fields[this.fieldName].class;

        if (currentClass.includes('uppercase')) {
            inputValue = inputValue.toUpperCase();
        } else if (currentClass.includes('downcase')) {
            inputValue = inputValue.toLowerCase();
        }

        return inputValue;
    }
  }
};
</script>

<style scoped>
.list-group-item {
  border: none; 
  border-bottom: 1px solid #e8e6e6; /* Aumenta ligeramente el grosor del borde para mejor visibilidad */
  background-color: #f1eeee; /* Mantén el fondo gris claro */
  text-align: center; /* Centra el texto verticalmente y horizontalmente */
  width: 100%; /* Asegura que el ancho ocupe el 100% del contenedor */
  padding: 10px 15px; /* Añade espacio interno para una mejor presentación */
  box-sizing: border-box; /* Incluye borde y padding dentro del ancho y alto total */
  border-radius: 0; /* Elimina cualquier redondeo de las esquinas */
}

.list-group-item:first-child {
  border-top-left-radius: 4px; /* Añade un ligero redondeo en las esquinas superiores */
  border-top-right-radius: 4px;
}

.list-group-item:last-child {
  border-bottom-left-radius: 4px; /* Añade un ligero redondeo en las esquinas inferiores */
  border-bottom-right-radius: 4px;
  border-bottom: none; /* Elimina el borde inferior del último elemento */
}
.uppercase { text-transform: uppercase; }
.lowercase { text-transform: lowercase; }
.capitalize {text-transform: capitalize; }
.clear-input {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    color: #ccc;
}

.clear-input:hover {
    color: #666;
}

.loading-icon {
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
}

/* Estilo para el icono de triángulo */
.dropdown-icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    color: #999;
}

.dropdown-icon i {
    font-size: 1.2em;
}

.dropdown-icon:hover {
    color: #666;
}
</style>

